"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

(function (webf) {
  webf.lang.fr = webf.lang.fr || {};
  webf.lang.fr.timepicker = {
    'Pick a time': 'Chosissez un moment'
  };
})(_core["default"]);